module.exports = __webpack_public_path__ + "static/media/soroush-karimi.29df8117.jpg";